export const MEDIA_MAX_SOURCE_BYTES = 2 * 1_024 * 1_024 * 1_024;
export const MEDIA_MAX_CAPTION_BYTES = 10 * 1_024 * 1_024;
export const MEDIA_PROCESSING_DERIVATIVE_MAX_BYTES = {
  playback: 2 * 1_024 * 1_024 * 1_024,
  poster: 8 * 1_024 * 1_024,
  "thumbnail-sprite": 24 * 1_024 * 1_024,
  waveform: 256 * 1_024,
} as const;
export const MEDIA_MAX_CAPTION_TRACKS = 16;
export const MEDIA_MAX_DURATION_SECONDS = 2 * 60 * 60;
export const MEDIA_MULTIPART_PART_BYTES = 16 * 1_024 * 1_024;
export const MEDIA_UPLOAD_CONCURRENCY = 4;
export const MEDIA_CAPABILITY_TTL_SECONDS = 5 * 60;
export const MEDIA_CLEANUP_GRACE_MS = 5 * 60 * 1_000;
export const MEDIA_CLEANUP_LEASE_MS = 60 * 1_000;
export const MEDIA_CLEANUP_MAX_ATTEMPTS = 5;
export const MEDIA_CLEANUP_BATCH_SIZE = 20;
export const MEDIA_NORMALIZED_MAX_WIDTH = 3_840;
export const MEDIA_NORMALIZED_MAX_HEIGHT = 1_080;
export const MEDIA_NORMALIZED_MAX_FRAME_RATE = 60;
export const MEDIA_NORMALIZED_AUDIO_SAMPLE_RATE = 48_000;
export const MEDIA_PROCESSING_LEASE_MS = 2 * 60 * 1_000;
export const MEDIA_PROCESSING_HEARTBEAT_MS = 30 * 1_000;
export const MEDIA_WAVEFORM_SAMPLE_COUNT = 512;
export const MEDIA_THUMBNAIL_SPRITE_FRAME_COUNT = 20;
